import "../styles/AdminInterface.css"
import React, { useState, useEffect } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { TextField, OutlinedInput,FormControl, InputLabel, Button,Tooltip, Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import BarChartIcon from '@mui/icons-material/BarChart';

import Checkbox from '@mui/material/Checkbox';
import { green } from '@mui/material/colors';
import { FormControlLabel } from '@mui/material';

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'


const AdminQuestions = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }

  const [groupes,setGroupes]=useState([])
  const options = ["Option 1", "Option 2", "Option 3", "Option 4"];


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.role !== undefined && !user.role.includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)
  const [numJeu, setNumJeu] = useState("Compta 1 - Attaque des cupcakes") //"Compta 1 - Attaque des cupcakes" 

  const [popupText, setPopupText] = useState(null)

  const [questions, setQuestions] = useState(null)
  const [localQuestions, setLocalQuestions] = useState(questions);
  const [popupQuestion, setPopupQuestion] = useState(null)
  const [newQuestion, setNewQuestion] = useState(null)

  const liste_jeux = ["Compta 1 - Attaque des cupcakes", "Compta 2 - Quiz en folie", "Compta 3 - Panique au PCG","Compta 4 - Balance ton écriture","Compta 5 - Belle brioche",
    "Compta 6 - Chamallows","SI 1 - Datman","SI 2 - Casse-tête ERP","SI 3 - Train de processus","SI 4 - Datacrush","SI 5 - Quiz en folie"]




  useEffect(async()=>{
    const fetchGroupes = async () => {
    if (groupes.length === 0) {
      const response = await BackendAPI.getGroupes();

      // ✅ On récupère juste la valeur "groupe" et on supprime les doublons
      const uniqueGroupes = [...new Set(response.map((g) => g.groupe))];

      setGroupes(uniqueGroupes);
      }
    };

    fetchGroupes();
  },[])


  useEffect(() => {
    if (questions == null) {
      clickActualiser()
    }
    setLocalQuestions(questions)
    // console.log(questions)
  }, [questions])



  useEffect(() => {
    setQuestions(null)
    setNewQuestion(null)
  }, [numJeu])


  const clickActualiser = async () => {
    // if (users == null){
    // console.log(numJeu)
    const questions = await BackendAPI.getQuestions(numJeu)
    // console.log(questions)
  //   const formattedQuestions = questions.map(q => ({
  //   ...q,
  //   groupes: q.groupes.replace(/;/g, ',')   // remplace tous les ';' par ','
  // .replace(/%%/g, ',')
  // }));
    setQuestions(questions)
    // }
    // setActualiser(false)

  }

  const updateServer = async (event, field, id) => {
    try {
      event.preventDefault()
    } catch (error) {
      
    }
    
    var value = "false"
    if (field !== "actif") {
      value = event.target.value?.replace("Phrase à trou","PhraseTrou")
    }

    await BackendAPI.updateQuestion(value, field, id, numJeu)
    //  setUsers(null)
  }

  const handleClicNewQuestion = async () => {
    await BackendAPI.createQuestion(newQuestion, numJeu)
    setNewQuestion(null)
    clickActualiser()
  }

  const handleChangeQuestion = (event, field, id) => {
    // setActualiser(true)
    // console.log(event.target.value)
    // console.log(field)
    // console.log(id)
    
    const newValue = event.target.value
    // Crée une nouvelle liste d'utilisateurs avec les modifications apportées
    const updatedQuestions = localQuestions.map(question =>
      question.id === id
        ? { ...question, [field]: newValue?.replace("Phrase à trou","PhraseTrou")
        }
        : question
    );
    // console.log("QUESTIONS")
    // console.log(updatedQuestions)
    // Met à jour l'état avec la nouvelle liste d'utilisateurs
    setLocalQuestions(updatedQuestions);
  };

  const handleChangeNewQuestion = (event, field) => {
    const newValue = event.target.value;
    const question = { ...newQuestion, [field]: newValue }
    setNewQuestion(question);
  };

  const handleKeyDown = (event, field, id) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      updateServer(event, field, id);
    }
  };

  const handleBlur = (event, field, id) => {
    updateServer(event, field, id);
  };

  const handleClicDelete = async (e, q) => {
    e.preventDefault()
    const reponse = q.reponse
    if (!e.target.checked) {
      const popupText = <Typography>
        Souhaitez-vous confirmer la suppression de la question suivante ?
        <br />
        Libellé: {q.libelle}

        {reponse != null && reponse.length > 0 ?
          <><br />
            Réponse: {reponse}
          </>
          : null}

        <br />
        {/* Niveau: {q.niveau} */}
      </Typography>
      setPopupQuestion(q)
      setPopupText(popupText)
    } else {
      await BackendAPI.updateQuestion("OUI", "actif", q.id, numJeu)
    }
    clickActualiser()
  }

  const [hoveredRow, setHoveredRow] = useState(null);

  const handleMouseEnter = (u) => {
    setHoveredRow(u);
  };

  const handleMouseLeave = () => {
    setHoveredRow(null);
  };


  const extractStats=(q)=>{
    if (q.statsReponsesVraies+q.statsReponsesFausses>0){
      var str = "Bonnes réponses : " + q.statsReponsesVraies + " ("+Math.round(q.statsReponsesVraies/(q.statsReponsesVraies+q.statsReponsesFausses)* 100)  +"%)"
      str = str + "<br>"
      str = str + "Mauvaises réponses : " + q.statsReponsesFausses + " ("+Math.round(q.statsReponsesFausses/(q.statsReponsesVraies+q.statsReponsesFausses)* 100)+"%)"
      str = str + "<br>"
      return str 
    }else{
      return "Aucune statistique"
    }
    
  }



  const renderQuestions = () => {
    if (localQuestions !== null) {

      if (numJeu.includes("Compta 1 -")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >

                  <TableCell align="center" style={{ width: 500 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 500 }}>Réponse</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center" style={{ width: 500 }}> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 500 }}> <TextField
                      value={q.reponse}
                      onChange={(e) => handleChangeQuestion(e, "reponse", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponse", q.id)}
                      onBlur={(e) => handleBlur(e, "reponse", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 50 }}> <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>

                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}} 
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}
                    
                    <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>


                    <TableCell align="center" style={{ width: 50 }}>
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}
                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)
      } else if (numJeu.includes("Compta 2 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow >
                  {/* <TableCell align="center" style={{ width: 80 }}>ID Question</TableCell>
                  <TableCell align="center" style={{ width: 150 }}>Type</TableCell> */}

                  <TableCell align="center" style={{ width: 550 }} >Libellé</TableCell>
                  <TableCell align="center"  style={{ width: 350 }}>Réponse vraie </TableCell>
                  <TableCell align="center"style={{ width: 350 }} >Réponse fausse 1</TableCell>
                  <TableCell align="center"style={{ width: 350 }} >Réponse fausse 2</TableCell>

                  <TableCell align="center" style={{ width: 80 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center"style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    {/*<TableCell align="center" >
                      <TextField
                      type="number"
                      value={q.idQuestion}
                      onChange={(e) => handleChangeQuestion(e, "idQuestion", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "idQuestion", q.id)}
                      onBlur={(e) => handleBlur(e, "idQuestion", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > 
                    <Select
                      value={q.typeQuestion?.replace("PhraseTrou","Phrase à trou")}
                      onChange={(e) => handleChangeQuestion(e, "typeQuestion", q.id)}
                      onBlur={(e) => handleBlur(e, "typeQuestion", q.id)}
                      variant="outlined"
                      size="small"
                    >
                      {["QCM","Association","Phrase à trou"].map(c => (
                        <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
                      ))}
                    </Select>
                    </TableCell>  */}
         {/*  <TextField
                      value={q.typeQuestion}
                      onChange={(e) => handleChangeQuestion(e, "typeQuestion", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "typeQuestion", q.id)}
                      onBlur={(e) => handleBlur(e, "typeQuestion", q.id)}
                      variant="outlined"
                      size="small"
                    />*/}
                    <TableCell align="center"  > <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      value={q.reponseVraie}
                      onChange={(e) => handleChangeQuestion(e, "reponseVraie", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseVraie", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseVraie", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"  > <TextField
                      value={q.reponseFausse1}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse1", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"  > <TextField
                      value={q.reponseFausse2}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse2", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}}
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}
                    
                    <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>

                    <TableCell align="center" >
                      
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                 
                    </TableCell>
                  </TableRow>
                ))}

                 {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

      } else if (numJeu.includes("Compta 3 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >

                  <TableCell align="center" style={{ width: 500 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center" style={{ width: 500 }}> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponse}
                      onChange={(e) => handleChangeQuestion(e, "reponse", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponse", q.id)}
                      onBlur={(e) => handleBlur(e, "reponse", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 100 }}> <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>

                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}}
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}
                     <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>
                    <TableCell align="center" style={{ width: 50 }}>
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)
      }else if (numJeu.includes("Compta 4 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >

                  <TableCell align="center" style={{ width: 500 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Gauche 1</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Gauche 2</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Droite 1</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Droite 2</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Fausse 1</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Fausse 2</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center" style={{ width: 500 }}> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseGauche1}
                      onChange={(e) => handleChangeQuestion(e, "reponseGauche1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseGauche1", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseGauche1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseGauche2}
                      onChange={(e) => handleChangeQuestion(e, "reponseGauche2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseGauche2", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseGauche2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseDroite1}
                      onChange={(e) => handleChangeQuestion(e, "reponseDroite1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseDroite1", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseDroite1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseDroite2}
                      onChange={(e) => handleChangeQuestion(e, "reponseDroite2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseDroite2", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseDroite2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseFausse1}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse1", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseFausse2}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse2", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 100 }}> <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>

                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}}
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}
                    
                     <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>

                    <TableCell align="center" style={{ width: 50 }}>
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)
      } else if (numJeu.includes("Compta 5 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 600 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Réponse</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center"> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      value={q.reponse}
                      onChange={(e) => handleChangeQuestion(e, "reponse", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponse", q.id)}
                      onBlur={(e) => handleBlur(e, "reponse", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}}
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}
                       <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>

                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

     
      }else if (numJeu.includes("Compta 6 - ")) {

        const ALLOWED_VALUES = [-1, 0, 1];

const handleRestrictedChange = (e, field, id, originalHandler) => {
  const v = e.target.value;

  if (v === "" || v === "-") {
    originalHandler(e, field, id);
    return;
  }

  const n = Number(v);
  if (ALLOWED_VALUES.includes(n)) {
    originalHandler(e, field, id);
  }
};

const handleRestrictedKeyDown = (e, field, id, originalHandler) => {
  const allowedKeys = [
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Enter",
    "-",
    "0",
    "1",
  ];

  if (!allowedKeys.includes(e.key)) {
    e.preventDefault();
    return;
  }

  originalHandler(e, field, id);
};

const handleRestrictedBlur = (e, field, id, originalHandler) => {
  let v = Number(e.target.value);

  if (!ALLOWED_VALUES.includes(v)) {
    v = 0;
  }

  // ⚠️ IMPORTANT → on renvoie une STRING pour éviter ton erreur
  originalHandler(
    { ...e, target: { ...e.target, value: String(v) } },
    field,
    id
  );
};



        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 500 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Actifs</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Amortissements</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Passifs</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Charges</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Produits</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Impact</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center"> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center">
  <TextField
    type="number"
    value={q.actifs}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedChange(e, "actifs", q.id, handleChangeQuestion)
    }
    onKeyDown={(e) =>
      handleRestrictedKeyDown(e, "actifs", q.id, handleKeyDown)
    }
    onBlur={(e) =>
      handleRestrictedBlur(e, "actifs", q.id, handleBlur)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

<TableCell align="center">
  <TextField
    type="number"
    value={q.amortissements}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedChange(e, "amortissements", q.id, handleChangeQuestion)
    }
    onKeyDown={(e) =>
      handleRestrictedKeyDown(e, "amortissements", q.id, handleKeyDown)
    }
    onBlur={(e) =>
      handleRestrictedBlur(e, "amortissements", q.id, handleBlur)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

<TableCell align="center">
  <TextField
    type="number"
    value={q.passifs}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedChange(e, "passifs", q.id, handleChangeQuestion)
    }
    onKeyDown={(e) =>
      handleRestrictedKeyDown(e, "passifs", q.id, handleKeyDown)
    }
    onBlur={(e) =>
      handleRestrictedBlur(e, "passifs", q.id, handleBlur)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

<TableCell align="center">
  <TextField
    type="number"
    value={q.charges}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedChange(e, "charges", q.id, handleChangeQuestion)
    }
    onKeyDown={(e) =>
      handleRestrictedKeyDown(e, "charges", q.id, handleKeyDown)
    }
    onBlur={(e) =>
      handleRestrictedBlur(e, "charges", q.id, handleBlur)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

<TableCell align="center">
  <TextField
    type="number"
    value={q.produits}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedChange(e, "produits", q.id, handleChangeQuestion)
    }
    onKeyDown={(e) =>
      handleRestrictedKeyDown(e, "produits", q.id, handleKeyDown)
    }
    onBlur={(e) =>
      handleRestrictedBlur(e, "produits", q.id, handleBlur)
    }
    variant="outlined"
    size="small"
  />
</TableCell>


                    <TableCell align="center" style={{ width: 120 }}>
                      <TextField
                        select
                        label="Impact"
                        value={q.impact}
                        onChange={(e) => handleChangeQuestion(e, "impact", q.id)}
                        onBlur={(e) => handleBlur(e, "impact", q.id)}
                        onKeyDown={(e) => handleKeyDown(e, "impact", q.id)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      >
                        <MenuItem value="Positif">Positif</MenuItem>
                        <MenuItem value="Neutre">Neutre</MenuItem>
                        <MenuItem value="Négatif">Négatif</MenuItem>
                      </TextField>
                    </TableCell>

                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                   
                       <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>

                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)
      }else if (numJeu.includes("SI 1 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 600 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 600 }}>Libellé Eng</TableCell>

                  <TableCell align="center" style={{ width: 100 }}>Réponse</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center"> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.libelleEng}
                      onChange={(e) => handleChangeQuestion(e, "libelleEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelleEng", q.id)}
                      onBlur={(e) => handleBlur(e, "libelleEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      value={q.reponse}
                      onChange={(e) => handleChangeQuestion(e, "reponse", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponse", q.id)}
                      onBlur={(e) => handleBlur(e, "reponse", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}}
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}


                     <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>


                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

     
    }else if (numJeu.includes("SI 2 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 600 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 600 }}>Libellé Eng</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Gateau</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  {/* <TableCell align="center" style={{ width: 50 }}>Stats</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center"> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.libelleEng}
                      onChange={(e) => handleChangeQuestion(e, "libelleEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelleEng", q.id)}
                      onBlur={(e) => handleBlur(e, "libelleEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.gateau}
                      onChange={(e) => handleChangeQuestion(e, "gateau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "gateau", q.id)}
                      onBlur={(e) => handleBlur(e, "gateau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>

                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}}
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}

                     {/* <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell> */}
                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

     
    }else if (numJeu.includes("SI 3 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 500 }}>Libellé Processus</TableCell>
                  <TableCell align="center" style={{ width: 500 }}>Libellé Procesus Eng</TableCell>
                  <TableCell align="center" style={{ width: 500 }}>Libellé Étape</TableCell>
                  <TableCell align="center" style={{ width: 500 }}>Libellé Étape Eng</TableCell>

                  <TableCell align="center" style={{ width: 100 }}>Ordre</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center"> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.libelleEng}
                      onChange={(e) => handleChangeQuestion(e, "libelleEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelleEng", q.id)}
                      onBlur={(e) => handleBlur(e, "libelleEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.libelleEtape}
                      onChange={(e) => handleChangeQuestion(e, "libelleEtape", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelleEtape", q.id)}
                      onBlur={(e) => handleBlur(e, "libelleEtape", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.libelleEtapeEng}
                      onChange={(e) => handleChangeQuestion(e, "libelleEtapeEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelleEtapeEng", q.id)}
                      onBlur={(e) => handleBlur(e, "libelleEtapeEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.numEtape}
                      onChange={(e) => handleChangeQuestion(e, "numEtape", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "numEtape", q.id)}
                      onBlur={(e) => handleBlur(e, "numEtape", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>

                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}}
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}

                     <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>
                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

     
    }else if (numJeu.includes("SI 4 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 400 }}>Donnée</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Donnée Eng</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Information</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Information Eng</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Connaissance</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Connaissance Eng</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center"> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.libelleEng}
                      onChange={(e) => handleChangeQuestion(e, "libelleEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelleEng", q.id)}
                      onBlur={(e) => handleBlur(e, "libelleEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.information}
                      onChange={(e) => handleChangeQuestion(e, "information", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "information", q.id)}
                      onBlur={(e) => handleBlur(e, "information", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.informationEng}
                      onChange={(e) => handleChangeQuestion(e, "informationEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "informationEng", q.id)}
                      onBlur={(e) => handleBlur(e, "informationEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.connaissance}
                      onChange={(e) => handleChangeQuestion(e, "connaissance", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "connaissance", q.id)}
                      onBlur={(e) => handleBlur(e, "connaissance", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.connaissanceEng}
                      onChange={(e) => handleChangeQuestion(e, "connaissanceEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "connaissanceEng", q.id)}
                      onBlur={(e) => handleBlur(e, "connaissanceEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>

                    {/* <TableCell align="center" sx={{
                      maxWidth: 100, // largeur max de la cellule
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      <Select
                        multiple
                        value={q.groupes ? q.groupes.split(",") : []} // préselection avec "groupes"
                        onChange={(e) => {
                          const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleChangeQuestion(
                            { target: { value: joinedValues } },
                            "groupes",
                            q.id
                          );
                          
                        }}
                        onBlur={(e) => {const selectedValues = e.target.value; // tableau
                          const joinedValues = selectedValues.join(","); // tableau -> chaîne
                          handleBlur( { target: { value: joinedValues } }, "groupes", q.id)}}
                        input={<OutlinedInput size="small" />}
                        sx={{ minWidth: 100, width: 150 }}
                        renderValue={(selected) => selected.join(",")} // affichage concaténé
                        style={{width:150}}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}

                     <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>
                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

     
    }else if (numJeu.includes("SI 5 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 400 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Libellé Eng</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Vraie</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Vraie Eng</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Fausse 1</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Fausse 1 Eng</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Fausse 2</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Fausse 2 Eng</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  {/* <TableCell align="center" style={{ width: 100 }}>Groupes</TableCell> */}
                  <TableCell align="center" style={{ width: 50 }}>Stats</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center"> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.libelleEng}
                      onChange={(e) => handleChangeQuestion(e, "libelleEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelleEng", q.id)}
                      onBlur={(e) => handleBlur(e, "libelleEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.reponseVraie}
                      onChange={(e) => handleChangeQuestion(e, "reponseVraie", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseVraie", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseVraie", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.reponseVraieEng}
                      onChange={(e) => handleChangeQuestion(e, "reponseVraieEng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseVraieEng", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseVraieEng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.reponseFausse1}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse1", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.reponseFausse1Eng}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse1Eng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse1Eng", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse1Eng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.reponseFausse2}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse2", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      value={q.reponseFausse2Eng}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse2Eng", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse2Eng", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse2Eng", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>


                    {/* <TableCell align="center">
                      <Select
                        multiple
                        value={q.monChampMulti ? q.monChampMulti.split(",") : []} // conversion string -> array
                        onChange={(e) => {
                          const selectedValues = e.target.value; // array
                          const joinedValues = selectedValues.join(","); // array -> string
                          handleChangeQuestion(
                            { target: { value: joinedValues } }, // pour garder la même signature que tes autres handlers
                            "monChampMulti",
                            q.id
                          );
                        }}
                        input={<OutlinedInput size="small" />}
                        style={{ minWidth: 150,width:150 }}
                      >
                        {groupes.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell> */}

                    
                    <TableCell align="center" style={{ cursor: "pointer" }}>
                        
                        <Tooltip
                          title={
                            hoveredRow && hoveredRow.id === q.id ? (
                              <span dangerouslySetInnerHTML={{ __html: extractStats(q) }} />
                            ) : ''
                          }
                          placement="right"
                          arrow
                        ><span
                        onMouseEnter={() => handleMouseEnter(q)}
                        onMouseLeave={handleMouseLeave}
                      >
                         <BarChartIcon  />
                      </span>
                         
                        </Tooltip>
                    </TableCell>

                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

     
    }
    return null

  }
}

  const renderNewQuestion = () => {

    var disabled = !newQuestion || !newQuestion.libelle || newQuestion.libelle.length === 0  /* || !newQuestion.niveau */

    if (numJeu.includes("Compta 1 -")) {
      return (
        /*  <TableContainer component={Paper}>
           <Table  aria-label="customized table">
             
             <TableBody> */
        <TableRow key={"NEW QUESTION"}>
          {/* <TableCell align="center"></TableCell> */}
          <TableCell align="center" style={{ width: 500 }}> <TextField
            label="Libellé"
            value={newQuestion != null ? newQuestion.libelle : ''}
            onChange={(e) => handleChangeNewQuestion(e, "libelle")}
            // onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"nom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 500 }}> <TextField
            label="Réponse"
            value={newQuestion != null ? newQuestion.reponse : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponse")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
            <TableCell align="center" style={{ width: 100 }}> <TextField
            label="Niveau"
            value={newQuestion != null ? newQuestion.niveau : ''}
            onChange={(e) => handleChangeNewQuestion(e, "niveau")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>    

          {/* <TableCell align="center" sx={{
            maxWidth: 100, // largeur max de la cellule
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            <Select
              multiple
              value={newQuestion != null && newQuestion.groupes!=null ? newQuestion.groupes.split(",") : []} // préselection avec "groupes"
              onChange={(e) => {
                const selectedValues = e.target.value; // tableau
                const joinedValues = selectedValues.join(","); // tableau -> chaîne
                handleChangeNewQuestion(
                  { target: { value: joinedValues } },
                  "groupes"
                );
                
              }}
              
              input={<OutlinedInput size="small" />}
              sx={{ minWidth: 100, width: 150 }}
              renderValue={(selected) => selected.join(",")} // affichage concaténé
              style={{width:150}}
            >
              {groupes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </TableCell> */}

          <TableCell align="center" style={{ width: 50 }}>
            <IconButton aria-label="ajouter" disabled={disabled}>
              <AddIcon
                color={disabled ? "default" : "secondary"}
                //  || !newUser.nom || newUser.nom.length === 0

                onClick={(e) => {
                  handleClicNewQuestion()
                  // handleClicDelete(u)
                  // handleBlur(e,"actif",u.id)
                }} />
            </IconButton>
          </TableCell>
        </TableRow>
        /*   </TableBody>
        </Table>
      </TableContainer> */
      )
    }else if (numJeu.includes("Compta 2 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
           {/*<TableCell align="center" >
        <TextField
          type="number"
          label="ID"

          value={newQuestion != null ? newQuestion.idQuestion : ''}
          onChange={(e) => handleChangeNewQuestion(e, "idQuestion")}

          variant="outlined"
          size="small"
        /></TableCell> */}
        {/* <TableCell align="center" > 
        <Select
          label="Type"

          value={newQuestion != null ? newQuestion.typeQuestion : ''}
          onChange={(e) => handleChangeNewQuestion(e, "typeQuestion")}
          variant="outlined"
          size="small"
        >
          {["QCM","Association","Phrase à trou"].map(c => (
            <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
          ))}
        </Select>
        </TableCell>  */}

        <TableCell align="center"><TextField
          label="Libellé"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center"><TextField
          label="Réponse vraie"
          value={newQuestion != null ? newQuestion.reponseVraie : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseVraie")}

          variant="outlined"
          size="small"
        /></TableCell>
       <TableCell align="center"><TextField
          label="Réponse fausse 1"
          value={newQuestion != null ? newQuestion.reponseFausse1 : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseFausse1")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center"><TextField
          label="Réponse fausse 2"
          value={newQuestion != null ? newQuestion.reponseFausse2 : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseFausse2")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          type="number"
          label="Niveau"

          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}

          variant="outlined"
          size="small"
        /></TableCell>
        {/* <TableCell align="center" sx={{
            maxWidth: 100, // largeur max de la cellule
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            <Select
              multiple
              value={newQuestion != null && newQuestion.groupes!=null ? newQuestion.groupes.split(",") : []} // préselection avec "groupes"
              onChange={(e) => {
                const selectedValues = e.target.value; // tableau
                const joinedValues = selectedValues.join(","); // tableau -> chaîne
                handleChangeNewQuestion(
                  { target: { value: joinedValues } },
                  "groupes"
                );
                
              }}
              
              input={<OutlinedInput size="small" />}
              sx={{ minWidth: 100, width: 150 }}
              renderValue={(selected) => selected.join(",")} // affichage concaténé
              style={{width:150}}
            >
              {groupes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </TableCell> */}
        <TableCell align="center" >
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    } else if (numJeu.includes("Compta 3 - ")) {
      return (
        /*   <TableContainer component={Paper}>
            <Table  aria-label="customized table">
              
              <TableBody> */
        <TableRow key={"NEW QUESTION"}>
          {/* <TableCell align="center"></TableCell> */}
          <TableCell align="center" style={{ width: 500 }}> <TextField
            label="Libellé"
            value={newQuestion != null ? newQuestion.libelle : ''}
            onChange={(e) => handleChangeNewQuestion(e, "libelle")}
            // onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"nom",u.id)}  
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse"
            value={newQuestion != null ? newQuestion.reponseGauche1 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponse")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 100 }}> <TextField
            label="Niveau"
            value={newQuestion != null ? newQuestion.niveau : ''}
            onChange={(e) => handleChangeNewQuestion(e, "niveau")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          {/* <TableCell align="center" sx={{
            maxWidth: 100, // largeur max de la cellule
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            <Select
              multiple
              value={newQuestion != null && newQuestion.groupes!=null ? newQuestion.groupes.split(",") : []} // préselection avec "groupes"
              onChange={(e) => {
                const selectedValues = e.target.value; // tableau
                const joinedValues = selectedValues.join(","); // tableau -> chaîne
                handleChangeNewQuestion(
                  { target: { value: joinedValues } },
                  "groupes"
                );
                
              }}
              
              input={<OutlinedInput size="small" />}
              sx={{ minWidth: 100, width: 150 }}
              renderValue={(selected) => selected.join(",")} // affichage concaténé
              style={{width:150}}
            >
              {groupes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </TableCell> */}
          <TableCell align="center" style={{ width: 50 }}>
            <IconButton aria-label="ajouter" disabled={disabled}>
              <AddIcon
                color={disabled ? "default" : "secondary"}
                //  || !newUser.nom || newUser.nom.length === 0

                onClick={(e) => {
                  handleClicNewQuestion()
                  // handleClicDelete(u)
                  // handleBlur(e,"actif",u.id)
                }} />
            </IconButton>
          </TableCell>
        </TableRow>
          /*   </TableBody>
          </Table>
        </TableContainer> */)
    }else if (numJeu.includes("Compta 4 - ")) {
      return (
        /*   <TableContainer component={Paper}>
            <Table  aria-label="customized table">
              
              <TableBody> */
        <TableRow key={"NEW QUESTION"}>
          {/* <TableCell align="center"></TableCell> */}
          <TableCell align="center" style={{ width: 500 }}> <TextField
            label="Libellé"
            value={newQuestion != null ? newQuestion.libelle : ''}
            onChange={(e) => handleChangeNewQuestion(e, "libelle")}
            // onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"nom",u.id)}  
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Gauche 1"
            value={newQuestion != null ? newQuestion.reponseGauche1 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseGauche1")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Gauche 2"
            value={newQuestion != null ? newQuestion.reponseGauche2 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseGauche2")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Droite 1"
            value={newQuestion != null ? newQuestion.reponseDroite1 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseDroite1")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Droite 2"
            value={newQuestion != null ? newQuestion.reponseDroite2 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseDroite2")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Fausse 1"
            value={newQuestion != null ? newQuestion.reponseFausse1 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseFausse1")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Fausse 2"
            value={newQuestion != null ? newQuestion.reponseFausse2 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseFausse2")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 100 }}> <TextField
            label="Niveau"
            value={newQuestion != null ? newQuestion.niveau : ''}
            onChange={(e) => handleChangeNewQuestion(e, "niveau")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>


          <TableCell align="center" style={{ width: 50 }}>
            <IconButton aria-label="ajouter" disabled={disabled}>
              <AddIcon
                color={disabled ? "default" : "secondary"}
                //  || !newUser.nom || newUser.nom.length === 0

                onClick={(e) => {
                  handleClicNewQuestion()
                  // handleClicDelete(u)
                  // handleBlur(e,"actif",u.id)
                }} />
            </IconButton>
          </TableCell>
        </TableRow>
          /*   </TableBody>
          </Table>
        </TableContainer> */)
    } else if (numJeu.includes("Compta 5 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" > <TextField
          label="Libellé"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Réponse"
          value={newQuestion != null ? newQuestion.reponse : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponse")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Niveau"
          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
       
        <TableCell align="center">
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    } else if (numJeu.includes("Compta 6 - ")) {

      const ALLOWED_VALUES = [-1, 0, 1];

const handleRestrictedNewChange = (e, field, originalHandler) => {
  const v = e.target.value;

  if (v === "" || v === "-") {
    originalHandler(e, field);
    return;
  }

  const n = Number(v);
  if (ALLOWED_VALUES.includes(n)) {
    originalHandler(e, field);
  }
};

const handleRestrictedNewKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Enter",
    "-",
    "0",
    "1",
  ];

  if (!allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};

const handleRestrictedNewBlur = (e, field, originalHandler) => {
  let v = Number(e.target.value);

  if (!ALLOWED_VALUES.includes(v)) {
    v = 0;
  }

  originalHandler(
    { ...e, target: { ...e.target, value: String(v) } },
    field
  );
};




      disabled=disabled && newQuestion?.actifs>=0 && newQuestion?.amortissements>=0 && newQuestion?.passifs>=0 && newQuestion?.charges>=0 && newQuestion?.produits>=0
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" style={{ width: 500 }}> <TextField
          label="Libellé"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" style={{ width: 100 }}>
  <TextField
    type="number"
    label="Actifs"
    value={newQuestion?.actifs ?? ""}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedNewChange(e, "actifs", handleChangeNewQuestion)
    }
    onKeyDown={handleRestrictedNewKeyDown}
    onBlur={(e) =>
      handleRestrictedNewBlur(e, "actifs", handleChangeNewQuestion)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

<TableCell align="center" style={{ width: 100 }}>
  <TextField
    type="number"
    label="Amort."
    value={newQuestion?.amortissements ?? ""}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedNewChange(e, "amortissements", handleChangeNewQuestion)
    }
    onKeyDown={handleRestrictedNewKeyDown}
    onBlur={(e) =>
      handleRestrictedNewBlur(e, "amortissements", handleChangeNewQuestion)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

<TableCell align="center" style={{ width: 100 }}>
  <TextField
    type="number"
    label="Passifs"
    value={newQuestion?.passifs ?? ""}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedNewChange(e, "passifs", handleChangeNewQuestion)
    }
    onKeyDown={handleRestrictedNewKeyDown}
    onBlur={(e) =>
      handleRestrictedNewBlur(e, "passifs", handleChangeNewQuestion)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

<TableCell align="center" style={{ width: 100 }}>
  <TextField
    type="number"
    label="Charges"
    value={newQuestion?.charges ?? ""}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedNewChange(e, "charges", handleChangeNewQuestion)
    }
    onKeyDown={handleRestrictedNewKeyDown}
    onBlur={(e) =>
      handleRestrictedNewBlur(e, "charges", handleChangeNewQuestion)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

<TableCell align="center" style={{ width: 100 }}>
  <TextField
    type="number"
    label="Produits"
    value={newQuestion?.produits ?? ""}
    inputProps={{ min: -1, max: 1, step: 1 }}
    onChange={(e) =>
      handleRestrictedNewChange(e, "produits", handleChangeNewQuestion)
    }
    onKeyDown={handleRestrictedNewKeyDown}
    onBlur={(e) =>
      handleRestrictedNewBlur(e, "produits", handleChangeNewQuestion)
    }
    variant="outlined"
    size="small"
  />
</TableCell>

        <TableCell align="center" style={{ width: 120 }}>
  <TextField
    select
    label="Impact"
    value={newQuestion != null ? newQuestion.impact : ''}
    onChange={(e) => handleChangeNewQuestion(e, "impact")}
    
    variant="outlined"
    size="small"
    fullWidth
  >
    <MenuItem value="Positif">Positif</MenuItem>
    <MenuItem value="Neutre">Neutre</MenuItem>
    <MenuItem value="Négatif">Négatif</MenuItem>
  </TextField>
</TableCell>

        <TableCell align="center" style={{ width: 100 }}  > <TextField
          label="Niveau"
          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
       
        <TableCell align="center">
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    }else if (numJeu.includes("SI 1 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" > <TextField
          label="Libellé"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Libellé Eng"
          value={newQuestion != null ? newQuestion.libelleEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelleEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Réponse"
          value={newQuestion != null ? newQuestion.reponse : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponse")}

          variant="outlined"
          size="small"
        /></TableCell>
        {/* <TableCell align="center" sx={{
            maxWidth: 100, // largeur max de la cellule
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            <Select
              multiple
              value={newQuestion != null && newQuestion.groupes!=null ? newQuestion.groupes.split(",") : []} // préselection avec "groupes"
              onChange={(e) => {
                const selectedValues = e.target.value; // tableau
                const joinedValues = selectedValues.join(","); // tableau -> chaîne
                handleChangeNewQuestion(
                  { target: { value: joinedValues } },
                  "groupes"
                );
                
              }}
              
              input={<OutlinedInput size="small" />}
              sx={{ minWidth: 100, width: 150 }}
              renderValue={(selected) => selected.join(",")} // affichage concaténé
              style={{width:150}}
            >
              {groupes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </TableCell> */}
        <TableCell align="center">
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    }else if (numJeu.includes("SI 2 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" > <TextField
          label="Libellé"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Libellé Eng"
          value={newQuestion != null ? newQuestion.libelleEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelleEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Gateau"
          value={newQuestion != null ? newQuestion.gateau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "gateau")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Niveau"
          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        {/* <TableCell align="center" sx={{
            maxWidth: 100, // largeur max de la cellule
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            <Select
              multiple
              value={newQuestion != null && newQuestion.groupes!=null ? newQuestion.groupes.split(",") : []} // préselection avec "groupes"
              onChange={(e) => {
                const selectedValues = e.target.value; // tableau
                const joinedValues = selectedValues.join(","); // tableau -> chaîne
                handleChangeNewQuestion(
                  { target: { value: joinedValues } },
                  "groupes"
                );
                
              }}
              
              input={<OutlinedInput size="small" />}
              sx={{ minWidth: 100, width: 150 }}
              renderValue={(selected) => selected.join(",")} // affichage concaténé
              style={{width:150}}
            >
              {groupes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </TableCell> */}
        <TableCell align="center">
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    }else if (numJeu.includes("SI 3 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" > <TextField
          label="Libellé Processus"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Libellé Processus Eng"
          value={newQuestion != null ? newQuestion.libelleEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelleEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Libellé Étape"
          value={newQuestion != null ? newQuestion.libelleEtape : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelleEtape")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Libellé Étape Eng"
          value={newQuestion != null ? newQuestion.libelleEtapeEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelleEtapeEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Ordre"
          value={newQuestion != null ? newQuestion.numEtape : ''}
          onChange={(e) => handleChangeNewQuestion(e, "numEtape")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Niveau"
          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        {/* <TableCell align="center" sx={{
            maxWidth: 100, // largeur max de la cellule
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            <Select
              multiple
              value={newQuestion != null && newQuestion.groupes!=null ? newQuestion.groupes.split(",") : []} // préselection avec "groupes"
              onChange={(e) => {
                const selectedValues = e.target.value; // tableau
                const joinedValues = selectedValues.join(","); // tableau -> chaîne
                handleChangeNewQuestion(
                  { target: { value: joinedValues } },
                  "groupes"
                );
                
              }}
              
              input={<OutlinedInput size="small" />}
              sx={{ minWidth: 100, width: 150 }}
              renderValue={(selected) => selected.join(",")} // affichage concaténé
              style={{width:150}}
            >
              {groupes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </TableCell> */}
        <TableCell align="center">
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    }else if (numJeu.includes("SI 4 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" > <TextField
          label="Donnée"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Donnée Eng"
          value={newQuestion != null ? newQuestion.libelleEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelleEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Information"
          value={newQuestion != null ? newQuestion.information : ''}
          onChange={(e) => handleChangeNewQuestion(e, "information")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Information Eng"
          value={newQuestion != null ? newQuestion.informationEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "informationEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Connaissance"
          value={newQuestion != null ? newQuestion.connaissance : ''}
          onChange={(e) => handleChangeNewQuestion(e, "connaissance")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Connaissance Eng"
          value={newQuestion != null ? newQuestion.connaissanceEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "connaissanceEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Niveau"
          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        {/* <TableCell align="center" sx={{
            maxWidth: 100, // largeur max de la cellule
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            <Select
              multiple
              value={newQuestion != null && newQuestion.groupes!=null ? newQuestion.groupes.split(",") : []} // préselection avec "groupes"
              onChange={(e) => {
                const selectedValues = e.target.value; // tableau
                const joinedValues = selectedValues.join(","); // tableau -> chaîne
                handleChangeNewQuestion(
                  { target: { value: joinedValues } },
                  "groupes"
                );
                
              }}
              
              input={<OutlinedInput size="small" />}
              sx={{ minWidth: 100, width: 150 }}
              renderValue={(selected) => selected.join(",")} // affichage concaténé
              style={{width:150}}
            >
              {groupes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </TableCell> */}
        <TableCell align="center">
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    }else if (numJeu.includes("SI 5 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" > <TextField
          label="Donnée"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Donnée Eng"
          value={newQuestion != null ? newQuestion.libelleEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelleEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Réponse Vraie"
          value={newQuestion != null ? newQuestion.reponseVraie : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseVraie")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Réponse Vraie Eng"
          value={newQuestion != null ? newQuestion.reponseVraieEng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseVraieEng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Réponse Fausse 1"
          value={newQuestion != null ? newQuestion.reponseFausse1 : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseFausse1")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Réponse Fausse 1 Eng"
          value={newQuestion != null ? newQuestion.reponseFausse1Eng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseFausse1Eng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Réponse Fausse 2"
          value={newQuestion != null ? newQuestion.reponseFausse2 : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseFausse2")}

          variant="outlined"
          size="small"
        /></TableCell>
         <TableCell align="center" > <TextField
          label="Réponse Fausse 2 Eng"
          value={newQuestion != null ? newQuestion.reponseFausse2Eng : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponseFausse2Eng")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Niveau"
          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        {/* <TableCell align="center" sx={{
            maxWidth: 100, // largeur max de la cellule
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            <Select
              multiple
              value={newQuestion != null && newQuestion.groupes!=null ? newQuestion.groupes.split(",") : []} // préselection avec "groupes"
              onChange={(e) => {
                const selectedValues = e.target.value; // tableau
                const joinedValues = selectedValues.join(","); // tableau -> chaîne
                handleChangeNewQuestion(
                  { target: { value: joinedValues } },
                  "groupes"
                );
                
              }}
              
              input={<OutlinedInput size="small" />}
              sx={{ minWidth: 100, width: 150 }}
              renderValue={(selected) => selected.join(",")} // affichage concaténé
              style={{width:150}}
            >
              {groupes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </TableCell> */}
        <TableCell align="center">
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    }

  }


  const handleClosePopup = async (choix) => {

    switch (choix) {
      case 'Supprimer Question':
        // setActualiser(true)
        await BackendAPI.updateQuestion("NON", "actif", popupQuestion.id, numJeu)


        setPopupQuestion(null)
        setQuestions(null)
    }

    setPopupText(null)
  }


  const handleClicNumJeu = async (event) => {
    event.preventDefault()
    setNumJeu(event.target.value)
    
    const questions = await BackendAPI.getQuestions(event.target.value)
    setQuestions(questions)
  }

const exportToCSV = () => {
  if (!localQuestions || localQuestions.length === 0) {
    alert("Aucune question à exporter !");
    return;
  }
  var headers=[]
  var rows = []

  if (numJeu.includes("Compta 1 -")) {
    headers = ["Id","Libellé", "Réponse", "Niveau","Actif","Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.reponse,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("Compta 2 -")) {
    headers = ["Id","Libellé", "Réponse Vraie", "Réponse Fausse 1","Réponse Fausse 2", "Niveau", "Actif", "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.reponseVraie,
      u.reponseFausse1,
      u.reponseFausse2,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("Compta 3 -")) {
    headers = ["Id","Libellé", "Réponse",  "Niveau", "Actif", "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.reponse,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("Compta 4 -")) {
    headers = ["Id","Libellé", "Réponse Gauche 1", "Réponse Gauche 2", "Réponse Droite 1","Réponse Droite 2","Réponse Fausse 1","Réponse Fausse 2","Niveau", "Actif", "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.reponseGauche1,
      u.reponseGauche2,
      u.reponseDroite1,
      u.reponseDroite2,
      u.reponseFausse1,
      u.reponseFausse2,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("Compta 5 -")) {
    headers = ["Id","Libellé", "Réponse",  "Niveau", "Actif",  "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.reponse,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("Compta 6 -")) {
    headers = ["Id","Libellé", "Actifs", "Amortissements","Passifs","Charges","Produits","Impact", "Niveau", "Actif",  "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.actifs,
      u.amortissements,
      u.passifs,
      u.charges,
      u.produits,
      u.impact,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("SI 1 - ")) {
    headers = ["Id","Libellé FR", "Libellé EN","Réponse", "Actif","Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.libelleEng,
      u.reponse,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("SI 2 - ")) {
    headers = ["Id","Libellé FR", "Libellé EN","Gateau", "Actif",  "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.libelleEng,
      u.gateau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("SI 3 - ")) {
    headers = ["Id","Libellé FR", "Libellé EN","Libellé Étape FR", "Libellé Étape EN","Numéro Étape", "Niveau", "Actif",  "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.libelleEng,
      u.libelleEtape,
      u.libelleEtapeEng,
      u.numEtape,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("SI 4 - ")) {
    headers = ["Id","Libellé FR", "Libellé EN","Information FR", "Information EN","Connaissance FR", "Connaissance EN","Niveau", "Actif",  "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.libelleEng,
      u.information,
      u.informationEng,
      u.connaissance,
      u.connaissanceEng,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }else if (numJeu.includes("SI 5 - ")) {
    headers = ["Id","Libellé FR", "Libellé EN","Réponse Vraie FR", "Réponse Vraie EN","Réponse Fausse 1 FR", "Réponse Fausse 1 EN","Réponse Fausse 2 FR", "Réponse Fausse 2 EN","Niveau", "Actif",  "Réponses bonnes","Réponses fausses"];
    rows = localQuestions.map(u => [
      u.id,
      u.libelle,
      u.libelleEng,
      u.reponseVraie,
      u.reponseVraieEng,
      u.reponseFausse1,
      u.reponseFausse1Eng,
      u.reponseFausse2,
      u.reponseFausse2Eng,
      u.niveau,
      u.actif,
      // u.groupes,
      u.statsReponsesVraies,
      u.statsReponsesFausses
    ]);
  }


  // Transformation en texte CSV
  const csvContent = [
    headers.join(";"), // séparateur ;
    ...rows.map(row => row.join(";"))
  ].join("\n");

  // Création du fichier Blob
  // const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  // Création d'un lien de téléchargement temporaire
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", "Questions "+numJeu+".csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div
        className="body-admin"
      >
        <Typography variant="h1" color="primary">Questions</Typography>
        <Divider />

        {/* <Button
          variant="contained"
          style={{padding:4}}
          className=""
          color={"primary"}
          // disabled={!actualiser}
        >
          {"Actualiser"}
        </Button> */}

        <div style={{ display: "flex", flex: 1, justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
          <Typography variant="h5" color="primary" style={{ width: 200 }}>Choix du jeu</Typography>
          <Select
            value={numJeu}
            variant="outlined"
            onChange={(e) => { handleClicNumJeu(e) }}
          >
            {liste_jeux.map(c => (
              <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
            ))}
          </Select>
           <IconButton aria-label="download" style={{padding:10}} onClick={exportToCSV} >
            <DownloadIcon 
            />
          </IconButton>
        </div>



        {
          popupText != null ?
            <Popup open={true} text={popupText} reponse={"Supprimer Question"} handleClose={handleClosePopup} ></Popup>
            :
            null
        }
        <div style={{ margin: 10 }}  >
          <br></br>
          {/*           <Typography variant="h5" color="primary">Liste de questions : {numJeu.split(" - ")[1]}</Typography>
 */}
          {renderQuestions()}

          {/*  <br></br> */}
          {/*  <Typography variant="h5" color="primary">Créer une nouvelle question</Typography>

          {renderNewQuestion()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>



        {/* </div> */}

      </div></div>
  );
}

export default AdminQuestions;


